import React from 'react';
import { Helmet } from 'react-helmet';
interface HeadProps {
  title?: string;
  description?: string;
  canonical?: string;
}
const Head: React.FC<HeadProps> = ({
  // IMPORTANTE: Este título padrão nunca deve ser alterado no build/deploy
  // Ele é o título SEO principal da aplicação e é crítico para indexação
  title = 'Semantic Branding — Otimize sua marca para LLMs | Conversion',
  description = 'Branding semântico é o conjunto de estratégias que conecta marcas a atributos específicos, fazendo com que inteligências artificiais as citem como referência.',
  canonical
}) => {
  return <Helmet data-id="element-1258" data-mp="2zydi2bdpm2w9">
      {/* Primary Meta Tags */}
      <title data-id="element-1259" data-mp="2zx2gmi7ql78b">{title}</title>
      <meta name="title" content={title} data-id="element-1260" data-mp="2uzsi8d2ddl8c" />
      <meta name="description" content={description} data-id="element-1261" data-mp="2uyr7yat6h2ro" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-1262" data-mp="3sfg2rkjpn4rk" />
      <meta property="og:title" content={title} data-id="element-1263" data-mp="3sh9al3627v15" />
      <meta property="og:description" content={description} data-id="element-1264" data-mp="3no7y11tbs7kq" />
      <meta property="og:image" content="https://www.conversion.com.br/wp-content/uploads/2022/05/logo-conversion.svg" data-id="element-1265" data-mp="3tutat64tikws" />
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-1266" data-mp="2nyuy25gfbvn" />
      <meta property="twitter:title" content={title} data-id="element-1267" data-mp="3k5rvzja0e9ke" />
      <meta property="twitter:description" content={description} data-id="element-1268" data-mp="3k35p7luxzy38" />
      <meta property="twitter:image" content="https://www.conversion.com.br/wp-content/uploads/2022/05/logo-conversion.svg" data-id="element-1269" data-mp="3p2ibo5hwj35a" />
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} data-id="element-1270" data-mp="3f6orbzxxy5cy" />}
      {/* Favicon */}
      <link rel="icon" href="https://uploadthingy.s3.us-west-1.amazonaws.com/8C7vgJpDx3uxVJnWZiQbAz/cropped-favicon-180x180.webp" type="image/webp" data-id="element-1271" data-mp="316npoi9uqtwf" />
    </Helmet>;
};
export default Head;